export default "__VITE_ASSET__C2bHAA5k__"